<template>
  <!-- zfKanBan -->
  <div :class="['zfkanban', { 'zfkanban-active': fangFlag }]">
    <div class="con">
      <div class="kanban-title">FITEE+智慧能源管理系统</div>
      <div class="my-weather my-flex">
        <div class="dushu my-flex">
          <img src="../../../assets/zhongfan/temperature.png" alt="" />
          <span>8°C</span>
        </div>
        <div class="dushu my-flex">
          <img src="../../../assets/zhongfan/humidity.png" alt="" />
          <span>16%</span>
        </div>
      </div>
      <div class="my-timer">
        {{ timerYMD }}
        <span>{{ timerWeek }}</span>
        {{ timerHMS }}
        <img
          src="../../../assets/zhongfan/fangda.png"
          alt=""
          @click="fangFlag = !fangFlag"
          v-show="!fangFlag"
        />
        <img
          src="../../../assets/zhongfan/suoxiao.png"
          alt=""
          @click="fangFlag = !fangFlag"
          v-show="fangFlag"
        />
      </div>
      <div class="top-con">
        <div class="top-left model-bg">
          <div class="small-title">
            <img src="@/assets/zhongfan/triangle.png" alt="" />
            <span>设备状态信息</span>
            <div class="line"></div>
          </div>
          <div class="mycontenr">
            <div class="con-item my-flex">
              <div class="item-left">
                <img src="@/assets/zhongfan/pressure.png" alt="" />
                <p>高压进线状态</p>
              </div>
              <div class="item-right ">
                <div class="r-item mrjuli">
                  <img src="@/assets/zhongfan/Closing.png" alt="" />
                  <p>1#进线</p>
                </div>
                <div class="r-item">
                  <img src="@/assets/zhongfan/opening.png" alt="" />
                  <p>2#进线</p>
                </div>
              </div>
            </div>
            <div class="item-line"></div>
            <div class="con-item my-flex">
              <div class="item-left" @click="toSvgPath">
                <img src="@/assets/zhongfan/transformer.png" alt="" />
                <p>变压器进线状态</p>
                <!-- 气象局1#变压器系统 -->
              </div>
              <div class="item-right">
                <div class="r-item mrjuli">
                  <img src="@/assets/zhongfan/Closing.png" alt="" />
                  <p>1#进线</p>
                </div>
                <div class="r-item">
                  <img src="@/assets/zhongfan/opening.png" alt="" />
                  <p>2#进线</p>
                </div>
                <div class="r-item mrjuli">
                  <img src="@/assets/zhongfan/Closing.png" alt="" />
                  <p>3#进线</p>
                </div>
                <div class="r-item">
                  <img src="@/assets/zhongfan/opening.png" alt="" />
                  <p>2#进线</p>
                </div>
              </div>
            </div>
            <div class="item-line"></div>
            <div class="con-item my-flex">
              <div class="item-left">
                <img src="@/assets/zhongfan/alternator.png" alt="" />
                <p>发电机状态</p>
              </div>
              <div class="item-right">
                <div class="r-item mrjuli">
                  <img src="@/assets/zhongfan/Closing.png" alt="" />
                  <p>1#进线</p>
                </div>
                <div class="r-item">
                  <img src="@/assets/zhongfan/opening.png" alt="" />
                  <p>2#进线</p>
                </div>
                <div class="tank mrjuli my-flex">
                  <span>1#油箱</span>
                  <div class="youimg">
                    0%
                  </div>
                </div>
                <div class="tank  my-flex">
                  <span>2#油箱</span>
                  <div class="youimg">
                    0%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="top-middle model-bg"
          @mouseenter="btnFlag = true"
          @mouseleave="btnFlag = false"
        >
          <div class="small-title">
            <img src="@/assets/zhongfan/triangle.png" />
            <span>一次主系统图{{ realPath }}</span>
            <div class="line"></div>
          </div>
          <div class="mysvg">
            <webSvgPlayer
              :svgpath="realPath"
              ref="webSvgPlayer"
              class="webSvgPlayer"
              slot="body"
            ></webSvgPlayer>
            <div
              class="add-svg"
              @click="dialogSvg = true"
              v-if="realPath == '' && btnFlag"
            >
              <i class="el-icon-plus"></i>
            </div>
            <div
              class="svg-btn"
              @click="dialogSvg = true"
              v-if="realPath != '' && btnFlag"
            >
              切换
            </div>
          </div>
        </div>
        <div class="top-right ">
          <div class="ups model-bg">
            <div class="small-title">
              <img src="@/assets/zhongfan/triangle.png" alt="" />
              <span>尖峰平谷</span>
              <div class="line"></div>
            </div>
            <div class="ups-con">
              <div id="chart_example" style="width:100%"></div>
            </div>
          </div>
          <div class="ups model-bg" style="margin-top:8px">
            <div class="small-title">
              <img src="@/assets/zhongfan/triangle.png" alt="" />
              <span>负荷信息</span>
              <div class="line"></div>
            </div>
            <div class="ups-con fuhe-con">
              <div class="fuhe-item">
                <div class="usePowerUnitBlock">
                  <p class="usePowerUnitBoxTitle">负荷设备数</p>
                  <p class="usePowerUnitBoxInfo">{{ DevicePower }}</p>
                </div>
                <div class="fuheimg">
                  <img :src="imgName('/huapu/loadValue.png')" />
                  <span>{{ MacRealValue || 0 }}</span>
                </div>
                <div class="fuhetitle">实时负荷</div>
              </div>
              <div class="fuhe-item" style="margin:0px 15px">
                <div class="usePowerUnitBlock">
                  <p class="usePowerUnitBoxTitle">日最大需量</p>
                  <p class="usePowerUnitBoxInfo">
                    {{ basicInforData.nowDayDemand }}
                  </p>
                </div>
                <div class="fuheimg">
                  <img :src="imgName('/huapu/loadValue.png')" />
                  <span>{{ DayMaxLoad || 0 }}</span>
                </div>
                <div class="fuhetitle">日最大负荷</div>
              </div>
              <div class="fuhe-item">
                <div class="usePowerUnitBlock">
                  <p class="usePowerUnitBoxTitle">月最大需量</p>
                  <p class="usePowerUnitBoxInfo">
                    {{ basicInforData.nowMonthDemand }}
                  </p>
                </div>
                <div class="fuheimg">
                  <img :src="imgName('/huapu/loadValue.png')" />
                  <span>{{ MonthMaxLoad || 0 }}</span>
                </div>
                <div class="fuhetitle">月最大负荷</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底层 -->
      <div class="bottom-con">
        <div class="botm-left  model-bg">
          <div class="small-title">
            <img src="@/assets/zhongfan/triangle.png" alt="" />
            <span>能源对标</span>
            <div class="line"></div>
          </div>
          <div class="shipin">
            <div id="energy" style="width:100%;height:100%"></div>
          </div>
        </div>
        <div class="botm-right  model-bg">
          <div class="small-title">
            <img src="@/assets/zhongfan/triangle.png" alt="" />
            <span>电量统计</span>
            <div class="line"></div>
          </div>
          <div class="danwei">
            单位：KW·h
          </div>
          <div class="botm-info">
            <div
              class="info-item"
              v-for="(item, index) in electricAnalyze"
              :key="index"
            >
              <span>{{ item.name }}</span>
              <p>{{ item.value }}</p>
            </div>
          </div>
          <div class="mychart">
            <div
              id="middle"
              ref="vchartBar"
              style="width:100%;height:100%"
            ></div>
          </div>
        </div>
        <div class="top-right ">
          <div class="police model-bg">
            <div class="small-title">
              <img src="@/assets/zhongfan/triangle.png" alt="" />
              <span>报警预警</span>
              <div class="line"></div>
            </div>
            <div class="police-top">
              <div class="po-num">
                <span>{{ monList.gaojing }}条</span>
                <p>月告警数</p>
              </div>
              <div class="myline"></div>
              <div class="po-num">
                <span>{{ todayList.gaojing }}条</span>
                <p>日告警数</p>
              </div>
              <div class="myline"></div>
              <div class="po-num">
                <span>{{ monList.yujing }}条</span>
                <p>月预警数</p>
              </div>
              <div class="myline"></div>
              <div class="po-num">
                <span>{{ todayList.yujing }}条</span>
                <p>日预警数</p>
              </div>
            </div>
            <div class="police-line"></div>
            <div class="police-tab">
              <div
                class="tab-item"
                v-for="(item, index) in monDataList"
                :key="index + 10"
              >
                <div class="tbtn warning" v-if="item.eventlevel == '1'">
                  预警
                </div>
                <div class="tbtn alarm" v-if="item.eventlevel == '2'">告警</div>
                <div class="tinfo">{{ item.description }}</div>
                <!-- <div class="ttimer">11-23 09:00</div> -->
                <div class="ttimer">{{ item.time | date_format }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出树形 -->
    <el-dialog
      width="20%"
      v-dialogDrag
      title="SVG图形"
      :close-on-click-modal="false"
      :visible.sync="dialogSvg"
    >
      <div class="address" style="height:500px">
        <svgTree
          ref="svgTree"
          @checkItem="nowSvg = $event"
          slot="tree"
        ></svgTree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSvg = false">取 消</el-button>
        <el-button type="primary" class="last-el-button" @click="nowPath_fn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import resourcesStore from "@/cache/resourcesStore.js";
import svgApi from "@/components/api/svgApi.js";
import svgTree from "@/components/module/tree/svgTree.vue";
import webSvgPlayer from "@/components/module/svg/webSvgPlayer.vue";
import request from "@/api/http.js";
import {
  getClassPGByMonthForHuaPu,
  mygetSvgTree,
} from "../../../api/abbNewApi";
export default {
  components: {
    svgTree,
    webSvgPlayer,
  },
  data() {
    return {
      selectTab: 0, //0今日1昨日2前日
      //能源对标
      proportionDataLine: {
        grid: {
          top: 30,
          bottom: 20,
          left: 40,
          right: 10,
          containLabel: false, // 是否包含坐标轴刻度标签，默认为false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#00ddff", "#ffc056", "#067bf0"],
        legend: {
          data: ["前日负荷", "昨日负荷", "今日负荷"],
          right: 10,
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            rotate: 0,
            textStyle: {
              color: "#CCCCCC",
            },
          },
        },
        yAxis: {
          splitLine: {
            // 控制x轴网格线颜色
            show: true,
            lineStyle: {
              color: "#666666",
              type: "dashed",
            },
          },
          type: "value",
          axisLabel: {
            interval: 0,
            rotate: 0,
            inside: false,
            textStyle: {
              color: "#CCCCCC",
            },
          },
        },
        series: [
          {
            name: "前日负荷",
            data: [0],
            type: "line",
          },
          {
            name: "昨日负荷",
            data: [0],
            type: "line",
          },
          {
            name: "今日负荷",
            data: [0],
            type: "line",
          },
        ],
      },
      //电量统计
      proportionData: {
        grid: {
          top: 30,
          bottom: 20,
          left: 40,
          right: 10,
          containLabel: false, // 是否包含坐标轴刻度标签，默认为false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#00ddff", "#ffc056"],
        legend: {
          data: ["电量", "电费"],
          right: 10,
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            rotate: 0,
            textStyle: {
              color: "#CCCCCC",
            },
          },
        },
        yAxis: {
          splitLine: {
            // 控制x轴网格线颜色
            show: true,
            lineStyle: {
              color: "#666666",
              type: "dashed",
            },
          },
          type: "value",
          axisLabel: {
            interval: 0,
            rotate: 0,
            inside: false,
            textStyle: {
              color: "#CCCCCC",
            },
          },
        },
        series: [
          {
            name: "电量",
            data: [0],
            type: "bar",
          },
          {
            name: "电费",
            data: [0],
            type: "bar",
          },
        ],
      },
      //尖峰平谷
      options: {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}   ({d}%)",
        },
        legend: {
          data: [],
        },
        label: {
          color: "white", // 修改文字颜色
          alignTo: "edge",
          formatter: "{name|{b}}\n{time|{c}}",
          minMargin: 0,
          edgeDistance: 10,
          lineHeight: 15,
          position: "outer",
          margin: 10,
          rich: {
            time: {
              fontSize: 10,
              color: "#fff",
            },
          },
          normal: {
            textStyle: {
              fontSize: 24,
            },
          },
        },
        color: ["#1f4dd6", "#f39e62", "#159e69", "#1b9bda"],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            labelLine: {
              normal: {
                length: 0,
              },
            },
            data: [
              { value: 0, name: "尖电量" },
              { value: 0, name: "峰电量" },
              { value: 0, name: "平电量" },
              { value: 0, name: "谷电量" },
            ],
            emphasis: {},
          },
        ],
      },
      dialogSvg: false, //控制svg图形弹出
      realPath: "",
      btnFlag: false,
      nowSvgItem: "",
      svgDataList: [],
      conformArr: [],
      svgPath: "",
      fangFlag: true,
      timerYMD: "",
      timerWeek: "",
      timerHMS: "",
      timerNull: "",
      getRowList: {},
      thisMonthData: [
        { value: 0, name: "尖电量" },
        { value: 0, name: "峰电量" },
        { value: 0, name: "平电量" },
        { value: 0, name: "谷电量" },
      ], //当月数据
      lastMonthData: [
        { value: 0, name: "尖电量" },
        { value: 0, name: "峰电量" },
        { value: 0, name: "平电量" },
        { value: 0, name: "谷电量" },
      ], //本月数据
      DevicePower: 0, //负荷设备数
      basicInforData: {}, //详细信息
      MacRealValue: 0, //实时数据
      mapkey: "", //实时数据 请求参数
      setTime: "", //定时器
      DayMaxLoad: 0, //本日最大值
      MonthMaxLoad: 0, //本月最大值
      setTime: null, //定时器
      todayLoadLine: [
        {
          data: [],

          showSymbol: false,
          type: "line",
          name: "前日负荷",
        },
        {
          data: [],

          showSymbol: false,
          type: "line",
          name: "昨日负荷",
        },
        {
          data: [],

          showSymbol: false,
          type: "line",
          name: "今日负荷",
        },
      ],
      electricAnalyze: [
        {
          name: "今年总耗电",
          value: "-",
        },
        {
          name: "今日电耗",
          value: "-",
          safe: 1,
        },
        {
          name: "昨日电耗",
          value: "-",
          safe: 1,
        },
        {
          name: "上月同期",
          value: "-",
          safe: 1,
        },
        {
          name: "本月电耗",
          value: "-",
          safe: 0,
        },
        {
          name: "上月电耗",
          value: "-",
          safe: 0,
        },
        {
          name: "去年同期",
          value: "-",
          safe: 0,
        },
      ], //电量

      powerDateList: {},
      todayList: {
        yujing: 0,
        gaojing: 0,
      }, //当日事件
      monList: {
        yujing: 0,
        gaojing: 0,
        data: [],
      }, //当月事件
      monDataList: [],
      timerList: null,
    };
  },

  mounted() {
    var _that = this;
    this.timerNull = setInterval(() => {
      // 获取当前日期
      const date = new Date();

      // 获取年份(4位,如2022)
      const year = date.getFullYear();

      // 获取月份(0-11,所以获取月份要加1)
      const month = date.getMonth() + 1;

      // 获取日期
      const day = date.getDate();

      // 获取周几(0-6,0表示周日)
      const week = date.getDay();

      // 24小时制时间
      const hours = date.getHours();

      // 分钟
      const minutes = date.getMinutes();

      // 秒
      const seconds = date.getSeconds();
      _that.timerYMD = year + "年" + month + "月" + day + "日";
      _that.timerWeek =
        "星期" + ["日", "一", "二", "三", "四", "五", "六"][week];
      _that.timerHMS =
        (hours > 10 ? hours : "0" + hours) +
        ":" +
        (minutes > 10 ? minutes : "0" + minutes) +
        ":" +
        (seconds > 10 ? seconds : "0" + seconds);
    }, 1000);

    function getDaysInMonth(year, month) {
      // month 参数是从 0 开始计数的，因此需要加 1
      const lastDay = new Date(year, month + 1, 0).getDate();
      return lastDay;
    }

    // 获取当前日期的年份和月份
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    // 调用函数获取本月天数
    const daysInCurrentMonth = getDaysInMonth(currentYear, currentMonth);

    var dayList = [];
    for (let i = 1; i <= daysInCurrentMonth; i++) {
      dayList.push(i < 10 ? "0" + i : i);
    }
    var dayList2 = [];
    for (let i = 0; i <= 23; i++) {
      dayList2.push(i < 10 ? "0" + i + ":00" : i + ":00");
    }
    this.proportionData.xAxis.data = dayList;
    this.proportionDataLine.xAxis.data = dayList2;

    //初始化图表
    this.init();

    if (
      JSON.stringify(this.getSvgTree) == "{}" ||
      this.getSvgTree == undefined
    ) {
      mygetSvgTree().then((res) => {
        if (res.success) {
          this.diguiFilter(this.nowUnit.id, [res.data]);
          this.digui_fn222(res.data);
        }
      });
    } else {
      this.diguiFilter(this.nowUnit.id, [this.getSvgTree]);
      this.digui_fn();
      this.nowSvgItem = this.$store.svgStore.state.nowSvgItem;
    }

    this.searchEvents(); //事件
    this.timerList = setInterval(() => {
      _that.searchEvents(); //事件
    }, 3600000);
  },
  computed: {
    getEventTypes() {
      return this.$store.eventStore.getters.searchAllEventTypes;
    },
    imgName() {
      return resourcesStore.getters.getResourcesByName;
    },
    getSvgTree() {
      var data = this.$store.svgStore.getters.getSvgTree;
      return data;
    },
    nowUnit() {
      return this.$store.unitStore.getters.getNowUnit;
    },
    dataList() {
      var data = this.svgDataList;
      return isempty(data) ? [] : svgList([data]);
    },
    svgList() {
      if (this.dataList[0] == undefined) {
        return [];
      }
      return treeToList(this.dataList[0], "next", (item) =>
        item.hasOwnProperty("next")
      ).filter((item) => item.entityName == "Page");
    },
  },
  beforeDestroy() {
    clearInterval(this.timerNull);
    clearInterval(this.setTime);
    clearInterval(this.timerList);
  },
  watch: {
    nowSvgItem(v) {
      if (v == undefined) {
        // this.digui(this.dataList)
        if (this.nowSvg != undefined) {
          this.realPath = "/static/svgFile/" + this.nowSvg.fileName;
        } else {
          this.realPath = "/static/svgFile/" + this.getRowList.fileName;
        }
        // this.realPath =  "/static/svgFile/" + '弹窗模板.wdr.7.svg'
      } else {
        this.nowSvg = v;
        this.realPath = "/static/svgFile/" + v.fileName;
        // this.realPath =  "/static/svgFile/" + '弹窗模板.wdr.7.svg'
      }
    },
    nowUnit(nv, ov) {
      this.diguiFilter(nv.id, [this.getSvgTree]);
    },
    dataList(nv) {},
    realPath() {
      this.tran_fn();
    },
    fangFlag() {
      setTimeout(() => {
        var proportion = echarts.init(document.getElementById("middle"));
        proportion.resize();
        var proportion2 = echarts.init(document.getElementById("energy"));
        proportion2.resize();
        var proportion3 = echarts.init(
          document.getElementById("chart_example")
        );
        proportion3.resize();
      }, 200);
    },
  },

  methods: {
    //点击变压器跳转页面
    toSvgPath() {
      this.$router.push("/svgList");
      // this.$router.push({name: 'svgList',params: {svgName: '气象局1#变压器系统'}})
    },
    init() {
      //用电
      var proportion = echarts.init(document.getElementById("middle"));
      proportion.setOption(this.proportionData, true);
      //能源对标
      var proportion2 = echarts.init(document.getElementById("energy"));
      proportion2.setOption(this.proportionDataLine, true);

      //尖峰平谷
      var myChart = echarts.init(document.getElementById("chart_example"));
      myChart.setOption(this.options, true);

      var _that = this;
      setTimeout(() => {
        _that.jianinitData();
      }, 200);
      setTimeout(() => {
        _that.getthreeList2();
      }, 300);
      setTimeout(() => {
        _that.getPowerValue();
      }, 400);
      setTimeout(() => {
        _that.getLoadinfo();
      }, 500);
      setTimeout(() => {
        _that.powerDate();
      }, 600);
      setTimeout(() => {
        _that.getBenyue();
      }, 700);
    },
    nowPath_fn() {
      this.$store.svgStore.commit("getNowSvg", this.nowSvg);
      this.nowSvgItem = this.nowSvg;
      this.dialogSvg = false;
    },
    tran_fn() {
      const iframe = document.querySelector(".iframe");
      iframe.addEventListener("load", () => {
        const svgDoc = iframe.contentDocument;
        const svgEl = svgDoc.querySelector("svg");
        const gEl = svgDoc.querySelectorAll("g");
        for (let i = 0; i < gEl.length; i++) {
          if (
            gEl[i].getAttribute("to") &&
            gEl[i].getAttribute("to") == "body开始 有它kitfox java版本的快会快"
          ) {
            var rescEl = gEl[i].querySelector("rect");
            rescEl.style.fill = "transparent";
          }
        }
        svgEl.style.backgroundColor = "transparent"; // 修改SVG图的fill颜色为透明色
      });
    },

    digui(list) {
      this.conformArr = [];
      list.forEach((item) => {
        if (!isempty(item.children)) {
          this.digui(item.children);
        } else {
          if (item.entityName == "Page") {
            this.conformArr.push(item);
          }
        }
      });
      this.nowSvg = this.conformArr[0];
    },
    diguiFilter(id, list) {
      list.forEach((item) => {
        if (item.id == id) {
          this.svgDataList = item;
        } else {
          if (!isempty(item.next)) {
            this.diguiFilter(id, item.next);
          }
        }
      });
    },
    digui_fn() {
      var dataList = [this.getSvgTree];

      var svgArr = [];
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.next && row.next.length != 0) {
              getStr(row.next);
            } else {
              svgArr.push(row);
            }
          });
        };
        getStr(dataList);
      };
      recursiveFunction();
      this.getRowList = svgArr[0];
    },
    digui_fn222(row) {
      var dataList = [row];

      var svgArr = [];
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.next && row.next.length != 0) {
              getStr(row.next);
            } else {
              svgArr.push(row);
            }
          });
        };
        getStr(dataList);
      };
      recursiveFunction();
      this.getRowList = svgArr[0];
      this.nowSvgItem = this.getRowList;
    },
    //尖峰平谷饼图数据
    jianinitData() {
      let atListDay = ""; //月最后一天
      let dataType = "";
      var nowdays = new Date();
      var year = nowdays.getFullYear();
      var month = nowdays.getMonth();
      if (month == 0) {
        month = 12;
        year = year - 1;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var myDate = new Date(year, month, 0);
      var endDate = year + "-" + month + "-" + myDate.getDate();
      switch (this.selectTab) {
        case 0:
          dataType = "当月";
          atListDay = nowdays.getTime();
          break;
        case 1:
          dataType = "上月";
          atListDay = nowdays.getTime();
          break;
      }
      this.$api.powerApi.getqueshengUnitPG(
        this.nowUnit.id,
        dataType,
        atListDay,
        (respon) => {
          if (!isempty(respon)) {
            respon.month.forEach((item, index) => {
              this.thisMonthData[index].value = item;
            });
            respon.lastMonth.forEach((item, index) => {
              this.lastMonthData[index].value = item;
            });

            this.thisMonthData.map((item, i) => {
              if (Number(item.value) < 0) {
                this.thisMonthData[i].value = 0;
              }
            });
            this.lastMonthData.map((item, i) => {
              if (Number(item.value) < 0) {
                this.lastMonthData[i].value = 0;
              }
            });

            //当月值
            this.options.series[0].data = this.thisMonthData;
            var myChart = echarts.init(
              document.getElementById("chart_example")
            );
            myChart.setOption(this.options, true);
          }
        }
      );
    },

    //获取事件
    searchEvents() {
      //获取当月事件
      this.getMonList();
      //获取当日事件
      this.gettodayList();
    },
    //获取今天的事件
    gettodayList() {
      let eventTypeNos = "";
      this.getEventTypes.forEach((item) => {
        eventTypeNos += "," + item.no;
      });
      // 获取当天的 00:00:00 的时间戳
      function getMidnightTimestamp() {
        const now = new Date();
        const midnight = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          0,
          0,
          0,
          0
        );
        return midnight.getTime();
      }
      // 获取当前时间的时间戳
      const currentTimestamp = Date.now();
      // 调用函数获取当天的 00:00:00 时间戳
      const midnightTimestamp = getMidnightTimestamp();
      var yuNum = 0;
      var gaoNum = 0;
      this.$api.eventApi.searchEventListByUser(
        undefined,
        this.nowUnit.id,
        eventTypeNos.substring(1),
        -1,
        -1,
        getValueIfNoNull(this.nowDevice, {}).no,
        midnightTimestamp,
        currentTimestamp,
        1,
        20,
        "",
        (respon) => {
          respon.data.forEach((item) => {
            if (item.eventlevel == "2") {
              //告警
              gaoNum += 1;
            }
            if (item.eventlevel == "1") {
              //预警
              yuNum += 1;
            }
          });
          this.todayList = {
            yujing: yuNum,
            gaojing: gaoNum,
          };
        }
      );
    },
    //获取当月事件
    getMonList() {
      let eventTypeNos = "";
      this.getEventTypes.forEach((item) => {
        eventTypeNos += "," + item.no;
      });
      // 获取当月的第一天的 00:00:00 的时间戳
      function getFirstDayOfMonthTimestamp() {
        const now = new Date();
        const firstDayOfMonth = new Date(
          now.getFullYear(),
          now.getMonth(),
          1,
          0,
          0,
          0,
          0
        );
        return firstDayOfMonth.getTime();
      }
      // 获取当前时间的时间戳
      const currentTimestamp = Date.now();
      // 调用函数获取当月的第一天的 00:00:00 时间戳
      const firstDayOfMonthTimestamp = getFirstDayOfMonthTimestamp();
      var yuNum = 0;
      var gaoNum = 0;
      this.$api.eventApi.searchEventListByUser(
        undefined,
        this.nowUnit.id,
        eventTypeNos.substring(1),
        -1,
        -1,
        getValueIfNoNull(this.nowDevice, {}).no,
        firstDayOfMonthTimestamp,
        currentTimestamp,
        1,
        20,
        "",
        (respon) => {
          // this.eventList=respon.data
          respon.data.forEach((item) => {
            if (item.eventlevel == "2") {
              //告警
              gaoNum += 1;
            }
            if (item.eventlevel == "1") {
              //预警
              yuNum += 1;
            }
          });

          this.monList = {
            yujing: yuNum,
            gaojing: gaoNum,
          };
          this.monDataList = respon.data.filter(
            (item) => item.eventlevel == 1 || item.eventlevel == 2
          );
        }
      );
    },
    //获取负荷信息
    getLoadinfo() {
      var params = { unitId: this.nowUnit.id, type: "load" };
      request({
        url: "/virtualDevice/getDeviceListByDeviceType.do",
        method: "post",
        params,
      }).then((res) => {
        //负荷设备数
        if (res.success) {
          this.DevicePower = res.data.length;
        }
      });
      request({ url: "/power/countRoomCount.do", method: "get", params }).then(
        (res) => {
          //配电房数量
          this.roomCount = res.roomCount;
        }
      );

      //本日最大值
      this.$api.powerApi.getDayMaxLoad(
        this.nowUnit.id,
        new Date().getTime(),
        (res) => {
          this.DayMaxLoad = res;
        }
      );

      //本月最大值
      this.$api.powerApi.getMonthMaxLoad(
        this.nowUnit.id,
        new Date().getTime(),
        (res) => {
          this.MonthMaxLoad = res;
        }
      );

      //详细信息
      var params = { unitId: this.nowUnit.id };
      request({ url: "/demand/findDemand", method: "get", params }).then(
        (res) => {
          if (res.code == 200) {
            this.basicInforData = res.data;
          }
        }
      );

      this.getList(); // 获取实时值
      if (this.setTime) {
        clearInterval(this.setTime);
      }
      this.setTime = setInterval(() => {
        this.getList(); // 获取实时值
      }, 5000);
    },
    // 获取实时值
    getList() {},
    xList() {
      //288
      var list = [];
      for (var h = 0, len = 24; h < len; h++) {
        for (var m = 0, lenm = 60; m < lenm; m += 5) {
          list.push((h < 10 ? "0" : "") + h + ":" + (m < 10 ? "0" : "") + m);
        }
      }
      return list;
    },
    //获取三日的负荷
    getthreeList2() {
      //获取负荷数据
      this.$api.powerApi.getUnitDayLoadValues(
        this.nowUnit.id,
        new Date(getDay(-2) + " 00:00:00").getTime(),
        (respon) => {
          this.todayLoadLine[0].data = respon; //前日负荷
          this.$api.powerApi.getUnitDayLoadValues(
            this.nowUnit.id,
            new Date(getDay(-1) + " 00:00:00").getTime(),
            (respon) => {
              this.todayLoadLine[1].data = respon; //昨日负荷
              this.$api.powerApi.getUnitDayLoadValues(
                this.nowUnit.id,
                new Date(getDay(0) + " 00:00:00").getTime(),
                (respon) => {
                  this.todayLoadLine[2].data = respon; //今日负荷
                  //能源对标
                  this.proportionDataLine.series = this.todayLoadLine;
                  this.proportionDataLine.xAxis.data = this.xList();
                  var proportion2 = echarts.init(
                    document.getElementById("energy")
                  );
                  proportion2.setOption(this.proportionDataLine, true);
                }
              );
            }
          );
        }
      );
    },
    //获取电量
    getPowerValue() {
      var unitId = this.nowUnit.id;
      if (isempty(unitId)) {
        return;
      }

      var now = new Date();
      var nowTime = now.getTime();
      var year = now.getFullYear();
      var month = now.getMonth();
      var day = now.getDate();
      var nowZero = new Date(year, month, day).getTime();
      //获取今年用电量
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        new Date(year, 0, 1).getTime(),
        nowTime,
        (respon) => {
          console.log("获取今年用电量", respon);
          this.electricAnalyze[0].value = Number(respon);
        }
      );
      //获取今日电量
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        nowZero,
        nowTime,
        (respon) => {
          console.log("获取今日电量", respon);
          this.electricAnalyze[1].value = Number(respon);
        }
      );
      //获取昨日电量
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        nowZero - 24 * 60 * 60 * 1000,
        nowZero - 1,
        (respon) => {
          console.log("获取昨日电量", respon);
          this.electricAnalyze[2].value = Number(respon);
        }
      );
      // 获取上个月同一天用电量，直接月份减1如果不存在就是空
      var lastMonthDate = new Date(year, month - 1, day);
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        lastMonthDate.getTime(),
        lastMonthDate.getTime() + 24 * 60 * 60 * 1000 - 1,
        (respon) => {
          console.log(
            "获取上个月同一天用电量，直接月份减1如果不存在就是空",
            respon
          );
          this.electricAnalyze[3].value = Number(respon);
        }
      );
      // 获取本月用电量
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        new Date(year, month, 1).getTime(),
        nowTime,
        (respon) => {
          console.log("获取本月用电量", respon);
          this.electricAnalyze[4].value = Number(respon);
        }
      );
      //获取上月用电量
      const datetimer = new Date();
      // 获取当前月份
      const newmonth = datetimer.getMonth();
      // 设置日期为上月最后一天
      datetimer.setMonth(newmonth);
      datetimer.setDate(0);
      // 设置时间为23:59:59
      datetimer.setHours(23);
      datetimer.setMinutes(59);
      datetimer.setSeconds(59);
      datetimer.setMilliseconds(999);
      // 获取时间戳(毫秒)
      // const timestamp = datetimer.getTime();
      var timestamp = new Date(year, month - 1, 1).getTime();
      var timestamp2 = new Date(year, month, 1).getTime() - 1;
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        timestamp,
        timestamp2,
        (respon) => {
          console.log("获取上月用电量", respon);
          this.electricAnalyze[5].value = Number(respon);
        }
      );
      //获取上月用电量
      // this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month - 1, 1).getTime(), new Date(year, month, day)
      // 	.getTime() -
      // 	1, respon => {
      // 		this.electricAnalyze[5].value = Number(respon)
      // 	})
      // 获取去年同月用电量
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        new Date(year - 1, month, 1).getTime(),
        new Date(this.getLastDay(year - 1, month + 1)).getTime(),
        (respon) => {
          console.log("获取去年同月用电量", respon);
          this.electricAnalyze[6].value = Number(respon);
        }
      );
    },
    //特殊本月电耗
    getBenyue() {
      var unitId = this.nowUnit.id;
      if (isempty(unitId)) {
        return;
      }

      var now = new Date();
      var nowTime = now.getTime();
      var year = now.getFullYear();
      var month = now.getMonth();
      var day = now.getDate();
      var nowZero = new Date(year, month, day).getTime();
      // 获取本月用电量
      this.$api.powerApi.getUnitUsePowerByDate(
        unitId,
        new Date(year, month, 1).getTime(),
        nowTime,
        (respon) => {
          console.log("获取本月用电量", respon);
          this.electricAnalyze[4].value = Number(respon);
        }
      );
    },
    getLastDay(year, month) {
      var new_year = year; //取当前的年份
      var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        new_month -= 12; //月份减
        new_year++; //年份增
      }
      var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
      return (
        year +
        "-" +
        new_month +
        "-" +
        new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate()
      ); //获取当月最后一天日期
    },
    //获取柱状图的电量
    powerDate() {
      if (!isempty(this.nowUnit.id)) {
        this.powerDateList = [];
        var id = this.nowUnit.id;

        var d = {
          timeStamp: new Date().getTime(),
          unitId: this.nowUnit.id,
        };
        getClassPGByMonthForHuaPu(d).then((res) => {
          // console.log("全胜请求",res);
          if (id == this.nowUnit.id) {
            //接口延迟时 只赋值当前的unit结果
            // this.powerDateList=res.data
            var resData = res.data;
            console.log("res.data", res.data);
            var power = []; //电量
            var money = []; //电费
            for (let key in resData) {
              power.push(resData[key]["总电量"]);
              money.push(resData[key]["总电费"]);
            }
            this.proportionData.series[0].data = power;
            this.proportionData.series[1].data = money;
            //用电
            var proportion = echarts.init(document.getElementById("middle"));
            proportion.setOption(this.proportionData, true);
          }
        });
      }
    },
  },
  filters: {
    // 转换时间戳
    date_format: function(value) {
      //value就是插值的数据
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let strDate = M + D + " " + h + m;
      return strDate;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;

  span {
    color: #67a3ed;
    font-size: 14px;
    font-weight: bold;
  }

  .el-icon-close {
    font-size: 20px !important;
  }
}

/deep/.el-dialog__footer {
  margin-top: 20px;
  text-align: right !important;
  border-top: 1px solid #e6e6e6;

  button {
    padding: 8px 17px;
  }
}

.demo-temp {
  display: flex;
  flex-wrap: wrap;
}

/deep/.el-form-item {
  display: flex;
  margin-left: 20px;
}

/deep/.el-form-item__label {
  white-space: nowrap;
  width: 90px;
}

/deep/.el-dialog__body {
  padding: 10px 0px 0px 20px !important;
}

.zfkanban {
  padding: 0px !important;
  // color: #0c97fc;

  .my-flex {
    display: flex;
    align-items: center;
  }

  p,
  span {
    color: #fff;
  }

  /deep/.framediv {
    width: 102%;
    height: 103%;
  }

  /deep/.svg {
    overflow: hidden;
  }

  .con {
    position: relative;

    width: 100%;
    height: 100%;
    background: url(../../../assets/zhongfan/zfbg.png) no-repeat;
    background-size: 100% 100%;
    // z-index: 9999;

    .kanban-title {
      font-size: 32px;
      font-weight: bold;
      letter-spacing: 4px;
      text-align: center;
      padding-top: 5px;
      background-image: linear-gradient(to top, #3bd3e5, #d8fbff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }

    .my-weather {
      margin-left: 1.8%;
      margin-top: -0.7%;

      .dushu {
        margin-right: 20px;
      }

      span {
        color: #56d6ff;
        margin-left: 6px;
      }
    }

    .my-timer {
      position: absolute;
      top: 4.1%;
      right: 1.3%;
      color: #3bd3e5;
      display: flex;
      align-items: center;

      span {
        color: #3bd3e5;
      }

      img {
        margin-left: 5px;
      }
    }

    .model-bg {
      padding: 12px 20px 0px 20px;
      box-sizing: border-box;

      .small-title {
        span {
          color: #3fbbff;
          font-size: 15px;
          font-weight: bold;
          margin-left: 6px;
        }

        .line {
          width: 100%;
          height: 1px;
          margin-top: 4px;
          background: linear-gradient(to right, #3fbbff, transparent);
        }
      }
    }

    .top-con {
      width: 100%;
      height: 53%;
      margin-top: 20px;
      padding: 0px 20px;
      box-sizing: border-box;
      display: flex;

      .top-left {
        width: 25%;
        height: 100%;
        background: url(../../../assets/zhongfan/modelbg1.png) no-repeat;
        background-size: 100% 100%;

        .mycontenr {
          width: calc(100% - 40px);
          height: calc(100% - 30px);
          margin-left: 20px;

          .con-item {
            width: 100%;
            height: 27.5%;
            margin: 11px 0px;
          }

          .item-line {
            width: 100%;
            height: 1px;
            background-color: rgba(63, 187, 255, 0.2);
          }
        }

        .item-left {
          width: 30%;
          height: 100%;
          text-align: center;

          img {
            width: 100%;
            height: 81%;
          }
        }

        .item-right {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          width: 70%;
          height: 100%;

          p {
            margin-top: -5px;
          }

          .tank {
            width: 40%;
            height: 40%;

            span {
              color: #fff;
            }

            .youimg {
              width: 35%;
              height: 100%;
              margin-left: 9px;
              background: url(../../../assets/zhongfan/subtractman.png)
                no-repeat;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 14px;
            }
          }

          .r-item {
            width: 40%;
          }

          .mrjuli {
            margin-left: 10px;
            margin-right: 20px;

            p,
            span {
              margin-left: 4px;
            }
          }
        }
      }

      .top-middle {
        width: calc(54% - 18px);
        height: 100%;
        margin: 0px 8px;
        background: url(../../../assets/zhongfan/modelbg2.png) no-repeat;
        background-size: 100% 100%;

        .mysvg {
          margin-top: 10px;
          width: 100%;
          height: calc(100% - 50px);
          position: relative;

          .add-svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 150px;
            height: 150px;
            border: 1px dashed #cccccc;
            border-radius: 4px;
            text-align: center;
            line-height: 150px;

            &:hover {
              border-color: #0c97fc;

              i {
                color: #0c97fc;
              }
            }

            i {
              color: #cccccc;
              font-size: 25px;
            }
          }

          .svg-btn {
            position: absolute;
            top: -45px;
            right: 0px;
            width: 50px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            color: #cccccc;
            border-radius: 4px;
            border: 1px solid #cccccc;
            cursor: pointer;

            &:hover {
              border-color: #0c97fc;
              color: #0c97fc;
            }
          }
        }
      }

      .top-right {
        width: 21%;
        height: 100%;

        .ups {
          width: 100%;
          height: calc(50% - 4px);
          background: url(../../../assets/zhongfan/modelbg1.png) no-repeat;
          background-size: 100% 100%;

          .ups-con {
            width: 100%;
            height: calc(100% - 35px);
            display: flex;
            justify-content: space-between;

            .ups-con-item {
              width: 70px;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              text-align: center;

              .youimg {
                margin-top: 8px;
                margin-bottom: 2px;
                width: 100%;
                height: 50px;
                display: flex;
                justify-content: center;
              }

              .youimgitem {
                width: 50%;
                height: 100%;
                background: url(../../../assets/zhongfan/subtractman.png)
                  no-repeat;
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 14px;
              }

              .younum {
                color: #fff;
                font-size: 13px;
                margin-bottom: 3px;
                margin-top: 3px;
              }

              .younum2 {
                color: #fff;
                font-size: 13px;
                margin-top: 10px;
                margin-bottom: 3px;
              }
            }
          }

          .fuhe-con {
            display: flex;
            justify-content: space-between;

            /* 平分空间 */
            .fuhe-item {
              text-align: center;

              .usePowerUnitBlock {
                margin: 8px 0px;
              }

              .fuheimg {
                width: 100%;
                position: relative;

                img {
                  width: 90%;
                }

                span {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);

                  color: #fff;
                  font-size: 16px;
                  font-weight: bold;
                }
              }

              .fuhetitle {
                color: #fff;
                text-align: center;
              }
            }
          }
        }
      }
    }

    .bottom-con {
      width: 100%;
      height: 35%;
      margin-top: 8px;
      padding: 0px 20px;
      box-sizing: border-box;
      display: flex;

      .botm-left {
        width: 25%;
        height: 100%;
        background: url(../../../assets/zhongfan/modelbg5.png) no-repeat;
        background-size: 100% 100%;

        .shipin {
          width: 100%;
          height: calc(100% - 45px);
          margin-top: 8px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .botm-right {
        width: calc(54% - 18px);
        height: 100%;
        margin: 0 8px;
        background: url(../../../assets/zhongfan/modelbg6.png) no-repeat;
        background-size: 100% 100%;
        position: relative;

        .botm-info {
          width: 100%;
          height: 65px;
          margin-top: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .info-item {
            width: 13%;
            height: 100%;
            background: url(../../../assets/zhongfan/group.png) no-repeat;
            background-size: 100% 100%;
            padding-top: 8px;
            box-sizing: border-box;

            span {
              font-size: 12px;
              margin-top: 8px;
              margin-left: 12px;
            }

            p {
              font-weight: bold;
              color: #98f4ff;
              margin-left: 12px;
              font-size: 16px;
              margin-top: 8px;
              letter-spacing: 1px;
              font-family: math;
            }
          }
        }

        .mychart {
          width: 100%;
          height: calc(100% - 130px);
          margin-top: 10px;
        }

        .danwei {
          position: absolute;
          top: 20px;
          right: 20px;
          color: #fff;
        }
      }
    }
  }
}

.top-right {
  width: 21%;
  height: 100%;

  .police {
    width: 100%;
    height: 100%;
    background: url(../../../assets/zhongfan/modelbg4.png) no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .police-top {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .po-num {
        width: 23%;
        text-align: center;

        span,
        p {
          white-space: nowrap;
        }

        span {
          font-size: 15px;
          color: #98f4ff;
          font-weight: bold;
        }

        p {
          font-size: 12px;
        }
      }

      .myline {
        width: 1px;
        height: 35px;
        background-color: rgba(63, 187, 255, 0.2);
      }
    }

    .police-line {
      width: 100%;
      height: 1px;
      background-color: rgba(63, 187, 255, 0.2);
    }

    .police-tab {
      width: 100%;
      height: calc(100% - 120px);
      margin-top: 10px;

      .tab-item {
        width: 100%;
        height: 20px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        .tbtn {
          min-width: 36px;
          height: 18px;
          border: 1px solid transparent;
          border-radius: 4px;
          font-size: 12px;
          // color: #FF7A00;
          text-align: center;
        }

        .warning {
          border-color: #ff7a00;
          color: #ff7a00;
        }

        .alarm {
          border-color: #ff3d00;
          color: #ff3d00;
        }

        .tinfo {
          flex-grow: 1;
          height: 100%;
          margin: 0px 12px 0px 4px;
          color: #fff;
          white-space: nowrap;
          /* 强制一行显示文本 */
          overflow: hidden;
          /* 超出部分隐藏 */
          text-overflow: ellipsis;
          /* 超出部分显示省略号 */
        }

        .ttimer {
          min-width: 80px;
          color: #cccccc;
        }
      }
    }
  }
}

.zfkanban-active {
  position: absolute;
  top: -50px;
  margin-top: 0px !important;
  height: 100% !important;
}

.usePowerUnitBoxInfo {
  height: 40px !important;
  line-height: 40px !important;
  font-weight: bold;
}
</style>
